export const START = 0;
export const RESULTS = 1;
export const POI = 2;
export const DIRECTIONSA = 3;
export const DIRECTIONSB = 4;


